module.exports = __webpack_public_path__ + "static/img/fail.fd814b5c.png";